import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiCheck } = FiIcons;

const SummaryIntellectualProperty = () => {
  const [selectedValue, setSelectedValue] = useState('');
  const [copied, setCopied] = useState(false);

  const data = {
    disenosIndustriales: {
      definition: "Con base en lo expuesto por la Organización: Mundial de la Propiedad Intelectual (OMPI, 2021), involucran los elementos estéticos de un producto, es decir, su apariencia y perspectiva visual."
    },
    esquemasCircuitos: {
      definition: "Producto con partes y conexiones internas con funcionamiento electrónico (Organización Mundial de la Propiedad Intelectual [OMPI], 1989)."
    },
    indicacionesGeograficas: {
      definition: "Signos que identifican productos originarios de una región específica, con características auténticas, excelente reputación y calidad (Organización Mundial de la Propiedad Intelectual [OMPI], 2021)."
    },
    marcas: {
      definition: "De acuerdo con la Superintendencia de Industria y Comercio (SIC, s.f.), son las representaciones visuales e iconográficas de un producto o servicio, que permite facilitar su identificación en el ámbito comercial."
    },
    nombresDominio: {
      definition: "La Organización Mundial de la Propiedad Intelectual (OMPI, 1999) es el ente encargado de resolver problemas con los nombres de dominios de empresas o personas cuando alguien los use de forma arbitraria y sin permisos."
    },
    patenteInvencion: {
      definition: "Es un mecanismo para salvaguardar las innovaciones de los inventos que aportan valor técnico (Superintendencia de Industria y Comercio [SIC], s.f.)."
    },
    patenteModeloUtilidad: {
      definition: "Conforme con lo establecido por la Superintendencia de Industria y Comercio (SIC, s.f.), ampara las nuevas configuraciones o formas de un invento que mejoran y optimizan su uso u operatividad."
    },
    patentes: {
      definition: "Corresponde al título de propiedad proporcionado por el Estado, con el propósito de que solo la persona que ideó y registró la invención pueda usarlo por un tiempo, y nadie más lo haga sin su permiso (Superintendencia de Industria y Comercio [SIC], s.f.)."
    },
    proteccionCompetencia: {
      definition: "Desde la perspectiva de la Organización Mundial de la Propiedad Intelectual (OMPI, 2016a), los países deben evitar prácticas injustas y deshonestas en el entorno comercial, entre ellas, cuando se genera confusión o difusión de falsedades alrededor de los productos de sus competidores."
    },
    secretosComerciales: {
      definition: "En el marco de la competitividad empresarial, la Organización Mundial de la Propiedad Intelectual (OMPI, s.f.) expresa la importancia de respetar la confidencialidad de la información privada o clasificada para no ser expuesta o comercializada."
    },
    variedadesVegetales: {
      definition: "Se otorgan derechos exclusivos y permisos especiales a quienes mejoran significativamente o desarrollan nuevas variedades de plantas, con resultados benéficos para agricultores y consumidores (Instituto Colombiano Agropecuario [ICA], s.f.; Unión Internacional para la Protección de las Obtenciones Vegetales [UPOV], s.f.)."
    },
    copyleft: {
      definition: "Está caracterizada por el libre uso, mejora y distribución de obras, como por ejemplo, se encuentra el movimiento de código abierto, el cual permite compartir y optimizar programas de forma para garantizar que las mismas libertades se mantengan para todos/as (Dusollier, 2010)."
    },
    creativeCommons: {
      definition: "Organización que permite compartir y usar trabajos con ciertos permisos que son claros para la audiencia (licencias), facilitando el uso legal de las obras y sus contenidos (Creative Commons, s.f.)."
    },
    derechoAutor: {
      definition: "Es el derecho que poseen los/las autores/as sobre sus creaciones para tener control de sus obras, cuyos privilegios trascienden en los aspectos literarios, artísticos y científicos (Organización Mundial de la Propiedad Intelectual [OMPI], 2021)."
    },
    derechoCita: {
      definition: "La Comunidad Andina (CAN, 1993), a través del artículo 22 de la Decisión 351 de 1993, expresa que es posible incluir fragmentos de diversas obras ajenas en el contexto académico e investigativo, sin autorización de los/las creadores/as ni pago de remuneraciones económicas, pero citando debidamente la fuente de información."
    },
    derechosConexos: {
      definition: "La Organización Mundial de la Propiedad Intelectual (OMPI, 2016b) establece que se resguardan los intereses de individuos y entidades vinculadas con la producción de obras generadas por artistas intérpretes y productores de grabaciones sonoras, así como los servicios encargados de su difusión."
    },
    derechosMorales: {
      definition: "Tienen la capacidad de intervenir en decisiones cuya finalidad es que los/las autores/as mantengan su relación con sus creaciones (Organización Mundial de la Propiedad Intelectual [OMPI], 2021)."
    },
    derechosPatrimoniales: {
      definition: "Para la Organización Mundial de la Propiedad Intelectual (OMPI, 2016b), conceden compensaciones económicas a los/las titulares como retribución por el uso sus creaciones."
    },
    dominioPublico: {
      definition: "En palabras Erickson (2015), es conjunto obras e ideas que se encuentran libres derechos autor para su uso irrestricto sin necesidad pedir autorización."
    },
    normatividadColombiana: {
      definition: "Incluye la Ley 23 de 1982, la Ley 599 de 2000 (artículos 270, 271, 272) y la Ley 1915 de 2018, que establecen el marco normativo para la protección del derecho de autor en Colombia (Congreso de Colombia, 1982, 2000, 2018)."
    }
  };

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    setCopied(false);
  };

  const copyToClipboard = () => {
    if (selectedValue && data[selectedValue]) {
      navigator.clipboard.writeText(data[selectedValue].definition);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-4xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent mb-6">
          Resumen - Propiedad intelectual
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Consulta las definiciones sobre propiedad intelectual
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 md:p-8">
        <div className="space-y-6">
          <select
            value={selectedValue}
            onChange={handleSelectChange}
            className="w-full p-4 text-lg border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">-- Selecciona una opción --</option>
            <optgroup label="Propiedad industrial">
              <option value="disenosIndustriales">Diseños industriales</option>
              <option value="esquemasCircuitos">Esquemas de trazado de circuitos integrados</option>
              <option value="indicacionesGeograficas">Indicaciones geográficas</option>
              <option value="marcas">Marcas</option>
              <option value="nombresDominio">Nombres de dominio de internet</option>
              <option value="patenteInvencion">Patente de invención</option>
              <option value="patenteModeloUtilidad">Patente de modelo de utilidad</option>
              <option value="patentes">Patentes</option>
              <option value="proteccionCompetencia">Protección contra la competencia desleal</option>
              <option value="secretosComerciales">Secretos comerciales</option>
              <option value="variedadesVegetales">Variedades vegetales</option>
            </optgroup>
            <optgroup label="Derecho de autor y derechos conexos">
              <option value="copyleft">Copyleft</option>
              <option value="creativeCommons">Creative Commons</option>
              <option value="derechoAutor">Derecho de autor</option>
              <option value="derechoCita">Derecho de cita</option>
              <option value="derechosConexos">Derechos conexos</option>
              <option value="derechosMorales">Derechos morales</option>
              <option value="derechosPatrimoniales">Derechos patrimoniales</option>
              <option value="dominioPublico">Dominio público</option>
              <option value="normatividadColombiana">Normatividad colombiana</option>
            </optgroup>
          </select>

          {selectedValue && data[selectedValue] && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mt-6 p-6 bg-gray-50 dark:bg-gray-700 rounded-lg"
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Definición:
                </h3>
                <motion.button
                  onClick={copyToClipboard}
                  className="flex items-center space-x-2 px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <SafeIcon icon={copied ? FiCheck : FiCopy} className="w-4 h-4" />
                  <span className="text-sm">{copied ? 'Copiado' : 'Copiar'}</span>
                </motion.button>
              </div>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-justify">
                {data[selectedValue].definition}
              </p>
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SummaryIntellectualProperty;